export enum TypePermission {
  null,
  read,
  write
}

export enum Scope {
  public,
  protected,
  private
}
